import React from "react";
import { Box, useTheme } from "@mui/material";
import OTPInput from "react-otp-input";
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

function CustomOTPInput({
  value,
  onChange,
  numInputs = 6,
  error,
  disabled = false,
  ...props
}) {
  const theme = useTheme();
  const { palette, typography, borders } = theme;
  const { primary, error: errorColor, grey, transparent } = palette;
  const { size } = typography;
  const { borderRadius } = borders;

  const inputStyle = {
    width: pxToRem(60),
    height: pxToRem(60),
    fontSize: size.lg,
    fontWeight: typography.fontWeightBold,
    letterSpacing: "0.1em",
    textAlign: "center",
    border: `${borders.borderWidth[2]} solid ${palette.inputBorderColor}`,
    borderRadius: borderRadius.md,
    margin: `0 ${pxToRem(4)}`,
    outline: "none",
    transition: "all 0.2s ease",
    backgroundColor: disabled ? grey[200] : transparent.main,
    color: disabled ? grey[500] : primary.main,
    cursor: disabled ? "not-allowed" : "text",
    fontFamily: typography.fontFamily,
  };

  const focusStyle = {
    border: `${borders.borderWidth[2]} solid ${primary.main}`,
    boxShadow: `0 0 0 ${pxToRem(3)} ${primary.main}20`,
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    gap: pxToRem(8),
  };

  return (
    <Box>
      <OTPInput
        value={value}
        onChange={onChange}
        numInputs={numInputs}
        inputType="number"
        shouldAutoFocus={true}
        renderInput={(inputProps) => (
          <input
            {...inputProps}
            style={inputStyle}
            disabled={disabled}
          />
        )}
        containerStyle={containerStyle}
        inputStyle={inputStyle}
        focusStyle={focusStyle}
        disabledStyle={{
          backgroundColor: grey[200],
          cursor: "not-allowed",
          color: grey[500],
        }}
        {...props}
      />
      {error && (
        <Box
          component="p"
          sx={{
            color: errorColor.main,
            fontSize: size.xs,
            fontWeight: typography.fontWeightLight,
            textAlign: "center",
            mt: 1,
            fontFamily: typography.fontFamily,
          }}
        >
          {error}
        </Box>
      )}
    </Box>
  );
}

CustomOTPInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  numInputs: PropTypes.number,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomOTPInput;
